import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

export const Container = styled.div`
  align-self: flex-start;
  display: flex;
  width: 100%;
`;

export const InnerContainer = styled.div`
  box-sizing: border-box;
  min-width: 50vw;
  display: flex;
  align-items: center;

  @media (max-width: ${breakpoints.lg}) {
    min-width: 100%;
    padding: 20px 5vw;
  }
`;
